export default class MacAddress {
    constructor(address) {
      this.originalAddress = address;
      this.address = this.transform(address);
      if (!this.isValid(this.address)) {
        throw new Error('Invalid MAC Address');
      }
    }
  
    transform(address) {
      return address.toUpperCase().replace(/:/g, '-');
    }
  
    isValid(address) {
      const regex = /^([0-9A-Fa-f]{2}-){5}[0-9A-Fa-f]{2}$/;
      return regex.test(address);
    }
  
    isLocal() {
      let msb = this.address.split('-')[0];
      let binary = parseInt(msb, 16).toString(2).padStart(8, '0');
      return binary[6] === '1';
    }
}
  
//   // Usage:
//   try {
//     const validMac = new MacAddress('00:1A:2B:3C:4D:5E');
//   } catch (err) {
//     console.error(err.message);
//   }
  
//   try {
//     const invalidMac = new MacAddress('INVALID-MAC-ADDRESS');
//   } catch (err) {
//     console.error(err.message);  // Outputs: "Invalid MAC Address"
//   }
  